import { createRouter, createWebHistory } from 'vue-router'

import { SystemUserRole } from '@/api-generator/aggr/api'
import ClientView from '@/views/frontend/ClientView.vue'

import AdminView from '../views/admin/AdminView.vue'
import HomeView from '../views/HomeView.vue'

import { setupRouterGuards } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/register/:invitation',
      name: 'register-invitation',
      component: () => import('../views/auth/RegisterLandingView.vue')
    },
    {
      path: '/link-invitation',
      name: 'register-link',
      component: () => import('../views/auth/RegisterLinkView.vue')
    },

    {
      path: '/auth-redirect',
      name: 'auth-redirect',
      component: () => import('../views/auth/AuthRedirect.vue')
    },
    {
      path: '/register-start',
      name: 'register-start',
      component: () => import('../views/auth/RegisterStepsView.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('../views/auth/ForgotPasswordView.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('../views/auth/ResetPasswordView.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminView,
      meta: {
        requiresAuth: true,
        requiresRole: [SystemUserRole.Admin, SystemUserRole.SuperUser, SystemUserRole.Guest]
      },
      children: [
        {
          path: 'tag-manage',
          name: 'tag-manage',
          component: () => import('../views/admin/TagManage.vue'),
          meta: {
            requiresRole: [SystemUserRole.Admin, SystemUserRole.SuperUser]
          }
        },
        {
          path: 'company-manage',
          name: 'company-manage',
          component: () => import('../views/admin/CompanyManage.vue'),
          meta: {
            requiresRole: [SystemUserRole.Admin, SystemUserRole.SuperUser]
          }
        },
        {
          path: 'organization-manage',
          name: 'organization-manage',
          component: () => import('../views/admin/OrganizationManage.vue'),
          meta: {
            requiresRole: [SystemUserRole.Admin, SystemUserRole.SuperUser, SystemUserRole.Guest]
          }
        },
        {
          path: 'user-manage',
          name: 'user-manage',
          component: () => import('../views/admin/UserManage.vue'),
          meta: {
            requiresRole: [SystemUserRole.Admin, SystemUserRole.SuperUser, SystemUserRole.Guest]
          }
        },
        {
          path: 'admin-manage',
          name: 'admin-manage',
          component: () => import('../views/admin/AdminManage.vue'),
          meta: {
            requiresRole: [SystemUserRole.Admin]
          }
        },
        {
          path: 'billing',
          name: 'billing',
          component: () => import('../views/admin/billing/BillingView.vue'),
          redirect() {
            return { name: 'billing-company-list' }
          },
          meta: {
            requiresRole: [SystemUserRole.Guest]
          },
          children: [
            {
              path: 'list',
              name: 'billing-company-list',
              component: () => import('../views/admin/billing/CompanyList.vue'),
              meta: {
                requiresRole: [SystemUserRole.Guest]
              }
            },
            {
              path: 'manage',
              name: 'billing-manage',
              component: () => import('../views/admin/billing/BillingManage.vue'),
              meta: {
                requiresRole: [SystemUserRole.Guest]
              }
            }
          ]
        }
      ]
    },
    {
      path: '/frontend',
      name: 'frontend',
      component: ClientView,
      meta: {
        requiresAuth: true
      },
      redirect() {
        return { name: 'shorter-list' }
      },
      children: [
        {
          path: 'shorter-list',
          name: 'shorter-list',
          meta: {
            keepAlive: true,
            componentName: 'ShorterList'
          },
          component: () => import('../views/frontend/ShorterSingleList.vue')
        },
        {
          path: 'group-list',
          name: 'group-list',
          meta: {
            requiresBatchCreate: true,
            keepAlive: true,
            componentName: 'GroupList'
          },
          component: () => import('../views/frontend/ShorterGroupList.vue')
        },
        {
          path: 'tag-stats',
          name: 'tag-stats',
          component: () => import('../views/frontend/AudienceTagList.vue')
        },
        {
          path: 'shorter-url/analytics',
          name: 'single-url-analytics',
          component: () => import('../views/frontend/dashboard/FeSingleUrlDashboard.vue')
        },
        {
          path: 'group-url/analytics',
          name: 'group-url-analytics',
          component: () => import('../views/frontend/dashboard/FeGroupUrlDashboard.vue'),
          meta: {
            requiresBatchCreate: true
          }
        },
        {
          path: 'tag-stats/analytics',
          name: 'tag-analytics',
          component: () => import('../views/frontend/dashboard/FeAudienceTagDashboard.vue')
        },
        {
          path: 'tag-stats/overlap',
          name: 'tag-overlap',
          component: () => import('../views/frontend/dashboard/FeTagOverlapDashboard.vue'),
          meta: {
            requiresOverlapFeature: true
          }
        }
      ]
    },
    {
      path: '/sso-binding',
      name: 'sso-binding',
      component: () => import('../views/frontend/SSOBinding.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue')
    }
  ]
})

// 設置路由守衛
setupRouterGuards(router)

export default router
